import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import styled from '@xstyled/styled-components';
import { Button, Image, Layout } from 'antd';
import { AppLogo } from './logo.component';
import { Responsive } from '../responsive';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var appHeaderDesktopHeight = 81;
export var appHeaderMobileHeight = 53;
var Header = Layout.Header;
export var appHeaderHeight = 64;
export var formHeaderHeight = 82;
var StyledHeader = styled(Header)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  border-bottom: 1px solid ", ";\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);\n  z-index: 12;\n  .ant-layout-header {\n    line-height: 0px !important;\n  }\n  ", ";\n  ", ";\n"])), function (props) {
  return props.theme.color.backgroundPrimary;
}, function (props) {
  return props.theme.color.borderDefault;
}, function (props) {
  return props.primaryHeader ? props.theme.media.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    "]))) : props.theme.media.desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding-left: 24px;\n  "])));
}, function (props) {
  return props.theme.media.mobile(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 16px;\n  "])));
});
var StyledLogo = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (props) {
  return props.theme.media.mobile(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin: auto;\n  "])));
});
var StyledHamburgerButton = styled(Button)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0px;\n"])));
export var AppHeader = function AppHeader(_ref) {
  var logoSrc = _ref.logoSrc,
      hamburgerHeaderSrc = _ref.hamburgerHeaderSrc,
      disabled = _ref.disabled,
      showDrawer = _ref.showDrawer,
      primaryHeader = _ref.primaryHeader,
      withoutSidebar = _ref.withoutSidebar;
  return /*#__PURE__*/_jsxs(StyledHeader, {
    primaryHeader: primaryHeader,
    children: [!primaryHeader && !withoutSidebar ? /*#__PURE__*/_jsx(Responsive.MobileScreen, {
      children: /*#__PURE__*/_jsx(StyledHamburgerButton, {
        type: "link",
        onClick: function onClick() {
          return showDrawer === null || showDrawer === void 0 ? void 0 : showDrawer();
        },
        children: /*#__PURE__*/_jsx(Image, {
          src: hamburgerHeaderSrc,
          preview: false,
          alt: "logo",
          width: 40,
          height: 40
        })
      })
    }) : null, /*#__PURE__*/_jsx(StyledLogo, {
      children: /*#__PURE__*/_jsx(AppLogo, {
        srcImg: logoSrc,
        disabled: disabled
      })
    })]
  });
};